import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TermsAndConditionContentComponent } from './shared-components/terms-and-condition-content/terms-and-condition-content.component';
import { AnnotationRecordsComponent } from './shared-components/annotation-records/annotation-records.component';
import { MatIconModule } from '@angular/material/icon';
import { AnnotationRecordsPrintPrvComponent } from './shared-components/annotation-records-print-prv/annotation-records-print-prv.component';

@NgModule({
    imports: [
    CommonModule,
    MatIconModule
    ],
    declarations : [
      TermsAndConditionContentComponent,
      AnnotationRecordsComponent,
      AnnotationRecordsPrintPrvComponent
    ],
    exports : [
      TermsAndConditionContentComponent,
      AnnotationRecordsComponent,
      AnnotationRecordsPrintPrvComponent
    ]
})

export class SharedModule { }
